import MaskHelper from '../helpers/MaskHelper';

export default class UserController {
  constructor(resource) {
    this._resource = resource;
  }

  async create(user) {
    let result = null;
    try {
      let response = await this._resource('user').save(user);
      result = {
        ok: response.ok,
        message: response.body.message,
      };
    } catch (error) {
      result = {
        ok: false,
        message: error.body.message,
      };
    }
    return result;
  }

  async createByAdm(user) {
    let result = null;
    try {
      let response = await this._resource('user-by-adm').save(user);
      result = {
        ok: response.ok,
        message: response.body,
      };
    } catch (error) {
      result = {
        ok: false,
        message: error.body.message,
      };
    }
    return result;
  }

  async publicCreate(user) {
    return this._resource('public/user')
      .save(user)
      .then(res => res)
      .catch(e => {
        throw e;
      });
  }

  async getUsersActiveByClientId(clientId) {
    return this._resource(`users/active/${clientId}`)
      .get()
      .then(res => res.body)
      .catch(e => {
        throw e;
      });
  }

  async getActiveByClientId(clientId, filters) {
    return this._resource(`users/profile_user/${clientId}`)
      .get({ filters })
      .then(res => res.body)
      .catch(e => {
        throw e;
      });
  }

  async getByClientIdForApproval() {
    return this._resource('users/for_approval')
      .get()
      .then(res => res.body)
      .catch(e => {
        throw e;
      });
  }

  async reprovarDocumentacao(id) {
    return this._resource(`user/reprove-doc/${id}`)
      .update()
      .then(res => res.body)
      .catch(e => {
        throw e;
      });
  }

  async userApproval(id) {
    let result;
    try {
      const res = await this._resource(`user/approval/${id}`).update();
      result = {
        ok: true,
        message: res.body,
      };
    } catch (error) {
      result = {
        ok: false,
        message: error.body.message,
      };
    }

    return result;
  }

  async getAllUsers(skip, filters) {
    const res = await this._resource(`users/by-filter`).get({ skip, filters });
    return res.body;
  }

  async getAllUsersToExport(filters) {
    // return this._resource(`users/by-filter`)
    return this._resource(`users/get-all`)
      .get({ filters })
      .then(res => res.body)
      .catch(e => {
        throw e;
      });
  }

  async findUser(name) {
    return this._resource('user/find')
      .get({ name })
      .then(res => res.body)
      .catch(e => {
        throw e;
      });
  }
  async getAllUsersReport() {
    return this._resource(`users-report`)
      .get()
      .then(res => res.body)
      .catch(e => {
        throw e;
      });
  }

  async getAllUsersByUser() {
    let result;
    try {
      let response = await this._resource(`users`).get();
      const userId = parseInt(localStorage.getItem('pickn_user'));
      response.body = response.body.filter(i => i.id != userId);
      // response.body = Object.keys(response.body).filter(key => response.body[key].id != userId)
      response.body.map(i => {
        i.profile_id = i.clientUser[0].profile_id;
        i.clientsUser = i.clientUser.map(i => {
          return {
            label: i.client.name,
            value: i.client_id,
          };
        });
      });
      let users = response.body.map(i => {
        return {
          name: i.name,
          user_id: i.id,
        };
      });
      result = users;
    } catch (error) {
      result = {
        ok: false,
        message: error.body.message,
      };
    }
    return result;
  }

  async getAllActiveUsersByUser() {
    let result;
    try {
      let response = await this._resource(`users/active`).get();
      response.body.map(i => {
        i.cpf = MaskHelper.maskCPF(i.cpf);
        i.profile_id = i.clientUser[0].profile_id;
        i.clientsUser = i.clientUser.map(i => {
          return {
            label: i.client.name,
            value: i.client_id,
          };
        });
        i.manager = i.manager_id
          ? {
              label: response.body.find(m => m.id == i.manager_id).name,
              value: response.body.find(m => m.id == i.manager_id).id,
            }
          : null;
      });
      result = response.body;
    } catch (error) {
      result = {
        ok: false,
        message: error.body.message,
      };
    }
    return result;
  }

  delete(userId) {
    return this._resource(`user/${userId}`)
      .delete()
      .then(
        res => res.data,
        error => {
          throw error.body;
        }
      );
  }

  forceDelete(userId) {
    return this._resource(`user/delete/${userId}`)
      .delete()
      .then(
        res => res.data,
        error => {
          throw error.body;
        }
      );
  }

  async update(user) {
    let result = null;
    try {
      let response = await this._resource(`user`).update(user);
      result = {
        ok: response.ok,
        message: response.body.message,
      };
    } catch (error) {
      console.log(error);
      result = {
        ok: false,
        message: error.body.message,
      };
    }
    return result;
  }

  async partialUpdate(user) {
    let result = null;
    try {
      let response = await this._resource(`user/partial`).update({
        id: user.id,
        birthday: user.birthday,
        phone: user.phone,
        cpf: user.cpf,
        email: user.email,
        drive_license: user.drive_license,
        confirmed_sms: user.confirmed_sms,
      });
      return (result = {
        ok: response.ok,
        message: response,
      });
    } catch (error) {
      throw error.body;
    }
  }

  async updateEmail(user) {
    let response = await this._resource(`users/email`).update(user);
    return {
      OK: response.ok,
      message: response.body.message,
    };
  }

  async resetPassword(user_id, new_password, hasForPasswordChange) {
    let response = await this._resource(
      `user/changePassword/${user_id}`
    ).update({
      user_id: user_id,
      password: new_password,
      hasForPasswordChange: hasForPasswordChange,
    });
    return {
      OK: response.ok,
      message: response.body.message,
    };
  }

  async setAddress(id_address) {
    let response = await this._resource(`user/setAddress`).update(id_address);
    return {
      OK: response.ok,
      message: response.body.message,
    };
  }

  getUserData() {
    return this._resource('user')
      .get()
      .then(
        res => res.json(),
        error => {
          throw new Error(error.body.message);
        }
      );
  }

  async getUserById(userId) {
    return this._resource(`user/${userId}`)
      .get()
      .then(res => res.body)
      .catch(e => {
        throw e;
      });
  }

  async getUserDetail(userId) {
    return this._resource(`user-detail/${userId}`)
      .get()
      .then(res => res.body)
      .catch(e => {
        throw e;
      });
  }

  async getDrivers() {
    let result;
    try {
      let response = await this._resource(`drivers`).get();
      result = response.body;
    } catch (error) {
      result = {
        ok: false,
        message: error.body.message,
      };
    }
    return result;
  }

  async importUsers(data) {
    let result;
    try {
      let response = await this._resource(`upload/user/import`).save(data);

      result = {
        ok: response.ok,
        message: response.body.message,
      };
    } catch (error) {
      result = {
        ok: false,
        message: error.body.message,
      };
    }
    return result;
  }

  async getProfile() {
    try {
      let response = await this._resource(`profile`).get();

      return response.body;
    } catch (error) {
      return error;
    }
  }

  async saveImgCnh(img) {
    return this._resource(`user/cnh`)
      .save(img)
      .then(res => res.body)
      .catch(error => {
        throw error;
      });
  }

  async sendSms() {
    return this._resource(`aws-sms/user/`)
      .save()
      .then(res => res.body)
      .catch(error => {
        throw error;
      });
  }

  async changeNumberAndHashAndSendSms(newPhone) {
    return this._resource(`aws-sms/user/new-phone-number/`)
      .update({
        phoneNumber: newPhone,
      })
      .then(res => res.body)
      .catch(error => {
        throw error;
      });
  }

  getAllAdms() {
    return this._resource(`user-adm`)
      .get()
      .then(res => res.body)
      .catch(e => {
        throw e;
      });
  }

  getAllNotApprovedUsers() {
    return this._resource(`user/not-aproved`)
      .get()
      .then(res => res.body)
      .catch(e => {
        throw e;
      });
  }

  getBlackListUsers() {
    return this._resource(`user/black_list`)
      .get()
      .then(res => res.body)
      .catch(e => {
        throw e;
      });
  }

  getAllInvitationsMade(id) {
    return this._resource(`user/all-invitations-made/${id}`)
      .get()
      .then(
        res => res.json(),
        error => {
          throw new Error(error.body.message);
        }
      );
  }

  getCnhByUser(id) {
    return this._resource(`cnh/public/${id}`)
      .get()
      .then(res => res.body)
      .catch(e => {
        throw e;
      });
  }
  getSelfieByUser(id) {
    return this._resource(`selfie/public/${id}`)
      .get()
      .then(res => res.body)
      .catch(e => {
        throw e;
      });
  }

  async getIndicationReport(beginDate, endDate) {
    return this._resource('reports/indications').get({
      datas: { beginDate, endDate },
    });
  }
}
